module.exports = __webpack_public_path__ + "static/media/injury.c4f200fb.svg";